import { CIcon } from '~/icons/types'

export const ciSemitrucks: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm23.961 14.155-1.5-8.872a.495.495 0 0 0-.056-.16c-.626-1.126-3.962-1.44-4.32-1.44h-6.11a.5.5 0 0 0-.5.5l.018 11.472H6.945a2.583 2.583 0 0 0-3.003-.191 2.708 2.708 0 0 0-.224.19H.5a.5.5 0 0 0-.5.5v2.164a.5.5 0 0 0 .5.5h2.458a2.589 2.589 0 0 0 2.364 1.499 2.62 2.62 0 0 0 2.265-1.3c.036-.063.063-.13.094-.2h6.991a2.606 2.606 0 0 0 4.718 0h4.11a.5.5 0 0 0 .5-.5l-.039-4.162ZM2.7 17.819H1v-1.163h1.914a2.62 2.62 0 0 0-.214 1.163Zm4.02.692a1.622 1.622 0 1 1-1.405-2.437H5.4a1.634 1.634 0 0 1 1.535 1.494c.027.328-.047.657-.213.943H6.72Zm4.754-.692H7.935a2.99 2.99 0 0 0 0-.328 2.668 2.668 0 0 0-.216-.832h3.758l-.003 1.16Zm11.5-2.75h-.721c-.108 0-.228-.135-.228-.331s.12-.332.228-.332h.715l.006.664Zm-.537-3.948h-5.354c-.1-.001-.2-.007-.3-.02a.694.694 0 0 1-.005-.09v-3.6c.175-.013.474-.013.784-.013h4.241l.634 3.723Zm-5.412 8.2a1.622 1.622 0 1 1 1.622-1.62 1.624 1.624 0 0 1-1.621 1.617l-.001.003Zm2.609-1.5c0-.041.012-.081.012-.123a2.622 2.622 0 1 0-5.243 0c0 .042.011.082.013.123H12.5l-.02-13.135h5.609a8.013 8.013 0 0 1 3.408.876l.142.838h-4.074c-1.261 0-1.784 0-1.784 1.109v3.5c0 .506.226 1.109 1.3 1.109h5.525l.218 1.285h-.572a1.336 1.336 0 0 0 0 2.664h.73L23 17.819l-3.366.002Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'semitrucks',
  type: 'thin'
}
